// Copyright (c) 2016 Deere & Company

import './maintenance-plan.scss';
import React, {PropTypes} from 'react';
import Criteria from '../state/criteria';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import MaintenancePlanDateRangeCriteria from './maintenance-plan-date-range-criteria';
import MaintenancePlanDealersCriteria from './maintenance-plan-dealers-criteria';
import MaintenancePlanInputCriteria from './maintenance-plan-input-criteria';
import MaintenancePlanServiceIntervalStatusCriteria from './maintenance-plan-service-interval-status-criteria';
import ReportCriteriaFooter from '../../shared/components/report-criteria-footer';

const MaintenancePlanCriteria = props =>
    <div className='maintenance-plan-criteria'>
        <div className='criteria-container'>
            <MaintenancePlanDealersCriteria
                onHandleDealersSelectChange={props.onHandleDealersSelectChange}
                onHandleSelectAllDealers={props.onHandleSelectAllDealers}
                selectedAccounts={props.selectedAccounts}
                selectedDealers={props.criteria.selectedDealers}
            />
            <MaintenancePlanInputCriteria
                criteria={props.criteria}
                onHandleModelInputChange={props.onHandleModelInputChange}
                onHandlePinInputChange={props.onHandlePinInputChange}
                onHandlePlanNamesSelectChange={props.onHandlePlanNamesSelectChange}
                onHandleServiceIntervalTypesSelectChange={props.onHandleServiceIntervalTypesSelectChange}
                planNames={props.planNames}
                serviceIntervalTypes={props.serviceIntervalTypes}
            />
            <MaintenancePlanDateRangeCriteria
                dateFormat={props.dateFormat}
                onHandlePlanEndDateChange={props.onHandlePlanEndDateChange}
                onHandlePlanStartDateChange={props.onHandlePlanStartDateChange}
                onHandleServiceIntervalBeginDateChange={props.onHandleServiceIntervalBeginDateChange}
                onHandleServiceIntervalEndDateChange={props.onHandleServiceIntervalEndDateChange}
                planEndDate={props.criteria.planEndDate}
                planStartDate={props.criteria.planStartDate}
                serviceIntervalBeginDate={props.criteria.serviceIntervalBeginDate}
                serviceIntervalEndDate={props.criteria.serviceIntervalEndDate}
            />
            <MaintenancePlanServiceIntervalStatusCriteria
                onHandleSelectAllServiceIntervalStatuses={props.onHandleSelectAllServiceIntervalStatuses}
                onHandleServiceIntervalStatusesSelectChange={props.onHandleServiceIntervalStatusesSelectChange}
                serviceIntervalStatuses={props.criteria.serviceIntervalStatuses}
            />
        </div>
        <ReportCriteriaFooter
            canExport={props.canExport}
            canRunReport={props.canRunReport}
            isRequired={true}
            onCriteriaReset={props.resetCriteria}
            onDownloadToExcel={props.onExportToCsv}
            onRunReport={props.onCreateReport}
            showExport={true}
            showReport={true}
        />
    </div>;

MaintenancePlanCriteria.displayName = 'MaintenancePlanCriteria';
MaintenancePlanCriteria.propTypes = {
    canExport: PropTypes.bool.isRequired,
    canRunReport: PropTypes.bool.isRequired,
    criteria: PropTypes.instanceOf(Criteria).isRequired,
    dateFormat: PropTypes.string.isRequired,
    onCreateReport: PropTypes.func.isRequired,
    onExportToCsv: PropTypes.func.isRequired,
    onHandleDealersSelectChange: PropTypes.func.isRequired,
    onHandleModelInputChange: PropTypes.func.isRequired,
    onHandlePinInputChange: PropTypes.func.isRequired,
    onHandlePlanEndDateChange: PropTypes.func.isRequired,
    onHandlePlanNamesSelectChange: PropTypes.func.isRequired,
    onHandlePlanStartDateChange: PropTypes.func.isRequired,
    onHandleSelectAllDealers: PropTypes.func.isRequired,
    onHandleSelectAllServiceIntervalStatuses: PropTypes.func.isRequired,
    onHandleServiceIntervalBeginDateChange: PropTypes.func.isRequired,
    onHandleServiceIntervalEndDateChange: PropTypes.func.isRequired,
    onHandleServiceIntervalStatusesSelectChange: PropTypes.func.isRequired,
    onHandleServiceIntervalTypesSelectChange: PropTypes.func.isRequired,
    planNames: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair).isRequired),
    resetCriteria: PropTypes.func.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    serviceIntervalTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair).isRequired)
};

export default MaintenancePlanCriteria;



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/components/maintenance-plan-criteria.js